import type { ThemePreset } from "../types";

export const vibrant: ThemePreset = {
  id: "vibrant",
  name: "Lebhaft",
  nameKey: "admin.settings.appearance.themes.vibrant.name",
  description: "Kräftige, verspielte Farben",
  descriptionKey: "admin.settings.appearance.themes.vibrant.description",
  light: {
    background: "oklch(0.985 0.005 300)",
    foreground: "oklch(0.15 0.02 300)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 300)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 300)",
    primary: "oklch(0.55 0.25 300)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.93 0.03 190)",
    "secondary-foreground": "oklch(0.20 0.02 300)",
    muted: "oklch(0.95 0.015 295)",
    "muted-foreground": "oklch(0.50 0.02 300)",
    accent: "oklch(0.90 0.05 190)",
    "accent-foreground": "oklch(0.20 0.02 200)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.91 0.02 295)",
    input: "oklch(0.91 0.02 295)",
    ring: "oklch(0.55 0.25 300)",
    "sidebar-background": "oklch(0.98 0.008 295)",
    "sidebar-foreground": "oklch(0.30 0.02 300)",
    "sidebar-primary": "oklch(0.55 0.25 300)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.92 0.035 190)",
    "sidebar-accent-foreground": "oklch(0.20 0.02 300)",
    "sidebar-border": "oklch(0.91 0.02 295)",
    "sidebar-ring": "oklch(0.55 0.25 300)",
  },
  dark: {
    background: "oklch(0.17 0.02 300)",
    foreground: "oklch(0.92 0.01 295)",
    card: "oklch(0.20 0.02 300)",
    "card-foreground": "oklch(0.92 0.01 295)",
    popover: "oklch(0.20 0.02 300)",
    "popover-foreground": "oklch(0.92 0.01 295)",
    primary: "oklch(0.68 0.20 300)",
    "primary-foreground": "oklch(0.15 0.02 300)",
    secondary: "oklch(0.30 0.04 190)",
    "secondary-foreground": "oklch(0.90 0.01 295)",
    muted: "oklch(0.25 0.02 300)",
    "muted-foreground": "oklch(0.65 0.02 295)",
    accent: "oklch(0.35 0.05 190)",
    "accent-foreground": "oklch(0.92 0.01 295)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.02 300)",
    input: "oklch(0.30 0.02 300)",
    ring: "oklch(0.68 0.20 300)",
    "sidebar-background": "oklch(0.14 0.02 300)",
    "sidebar-foreground": "oklch(0.82 0.015 295)",
    "sidebar-primary": "oklch(0.68 0.20 300)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 300)",
    "sidebar-accent": "oklch(0.25 0.04 190)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 295)",
    "sidebar-border": "oklch(0.28 0.02 300)",
    "sidebar-ring": "oklch(0.68 0.20 300)",
  },
};
